import styled, { css } from 'styled-components';
import { isDefaultTheme, isGlobetrotter } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';

var Accordion = styled.div.withConfig({
  displayName: "Accordionstyle__Accordion",
  componentId: "sc-1ppumk8-0"
})(["overflow:hidden;", ""], isDefaultTheme(css(["border-radius:var(--border-radius-500);box-shadow:var(--elevation-100);background-color:var(--color-background-surface-primary);"])));
var AccordionItem = styled.div.withConfig({
  displayName: "Accordionstyle__AccordionItem",
  componentId: "sc-1ppumk8-1"
})(["border-bottom:1px solid var(--color-border-key-line);", " ", ""], isDefaultTheme(css(["&:last-child{border-bottom:none;}"])), isGlobetrotter(css(["&:first-child{border-top:1px solid var(--color-border-key-line);}"])));
var AccordionHeader = styled.button.withConfig({
  displayName: "Accordionstyle__AccordionHeader",
  componentId: "sc-1ppumk8-2"
})(["font:var(--font-headline-s);text-align:left;display:flex;align-items:center;justify-content:space-between;align-self:stretch;width:100%;padding:var(--space-400);gap:var(--space-400);", " ", " ", " &:focus-visible{outline-offset:-8px;box-shadow:none;}.uikit-accordion-icon{transition:transform var(--transition);}", ""], mq.s(css(["padding:var(--space-500);gap:var(--space-500);"])), mq.m(css(["padding:var(--space-500) var(--space-700);gap:var(--space-700);"])), isGlobetrotter(css(["font:var(--font-headline-xs);padding:var(--space-400) var(--space-200) var(--space-400) 0;", " ", ""], mq.s(css(["padding:var(--space-500) var(--space-400);"])), mq.m(css(["padding:var(--space-500) var(--space-400);"])))), function (_ref) {
  var $isOpen = _ref.$isOpen;
  return $isOpen && css([".uikit-accordion-icon{transform:rotate(180deg);}"]);
});
var AccordionHeaderContent = styled.div.withConfig({
  displayName: "Accordionstyle__AccordionHeaderContent",
  componentId: "sc-1ppumk8-3"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:center;width:100%;"]);
var AccordionSubHeader = styled.span.withConfig({
  displayName: "Accordionstyle__AccordionSubHeader",
  componentId: "sc-1ppumk8-4"
})(["font:var(--font-body-m);"]);
var AccordionContentWrapper = styled.div.withConfig({
  displayName: "Accordionstyle__AccordionContentWrapper",
  componentId: "sc-1ppumk8-5"
})(["display:grid;grid-template-rows:0fr;transition:all var(--transition);", ""], function (_ref2) {
  var $isOpen = _ref2.$isOpen;
  return $isOpen && css(["margin-bottom:var(--space-400);grid-template-rows:1fr;", ""], mq.s(css(["margin-bottom:var(--space-500);"])));
});
var AccordionContent = styled.div.withConfig({
  displayName: "Accordionstyle__AccordionContent",
  componentId: "sc-1ppumk8-6"
})(["overflow:hidden;padding-bottom:var(--space-50);padding-inline:var(--space-400);", " ", " ", ""], mq.s(css(["padding-inline:var(--space-500);"])), mq.m(css(["padding-inline:var(--space-700);"])), isGlobetrotter(css(["padding-inline:0;", " ", ""], mq.s(css(["padding-inline:var(--space-400);"])), mq.m(css(["padding-inline:var(--space-400);"])))));

export { Accordion, AccordionContent, AccordionContentWrapper, AccordionHeader, AccordionHeaderContent, AccordionItem, AccordionSubHeader };
//# sourceMappingURL=Accordion.style.js.map
